// // frontend/src/pages/Profile.js

// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import '../styles/profile.css';

// const Profile = () => {
//   const [userData, setUserData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const navigate = useNavigate();

//   useEffect(() => {
//   const fetchUserDetails = async () => {
//     try {
//       const token = localStorage.getItem('token');
//       console.log('Token:', token); // Debugging token
//       if (!token) {
//       navigate('/login'); 
//         return;
//       }

//       const response = await axios.get('/api/auth/profile', {
//         headers: { Authorization: `Bearer ${token}` },
//       });

//     console.log('Profile Data:', response.data); // Debug API response
//       setUserData(response.data.user);
//     } catch (error) {
//       console.error('Error fetching user details:', error);
//       setError('Failed to fetch user details. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   };
//   fetchUserDetails();
// }, [navigate]);


//   if (loading) return <p>Loading...</p>;
//   if (error) return <p>{error}</p>;
//   if (!userData) return <p>No user data found.</p>;

//   return (
//     <div className="profile-container">
//       <h2 className="profile-title">Profile Page</h2>
//       <div className="profile-content">
//         <div className="profile-item">
//           <span className="profile-label">First Name:</span>
//           <span className="profile-value">{userData.firstName}</span>
//         </div>
//         <div className="profile-item">
//           <span className="profile-label">Last Name:</span>
//           <span className="profile-value">{userData.lastName}</span>
//         </div>
//         {/* <div className="profile-item">
//           <span className="profile-label">User Type:</span>
//           <span className="profile-value">
//             {userData.userType === 'LegalAdvisor' ? 'Legal Advisor' : 'Public User'}
//           </span>
//         </div> */}
//         <div className="profile-item">
//           <span className="profile-label">Country:</span>
//           <span className="profile-value">{userData.country}</span>
//         </div>
//         <div className="profile-item">
//           <span className="profile-label">State:</span>
//           <span className="profile-value">{userData.state}</span>
//         </div>
//         <div className="profile-item">
//           <span className="profile-label">District:</span>
//           <span className="profile-value">{userData.district}</span>
//         </div>
//         <div className="profile-item">
//         <span className="profile-label">Email:</span>
//           {/* <span className="profile-label">Email/Mobile:</span> */}
//           {/* <span className="profile-label">Mobile:</span> */}
//           <span className="profile-value">{userData.emailOrPhone || userData.email}</span>
//         </div>

//         {/* Legal Advisor Only Fields */}
//         {userData.userType === 'LegalAdvisor' && (
//           <>
//             <div className="profile-item">
//               <span className="profile-label">Bar Council Number:</span>
//               <span className="profile-value">{userData.barCouncilNumber}</span>
//             </div>
//             <div className="profile-item">
//               <span className="profile-label">Specialization:</span>
//               <span className="profile-value">{userData.specialization}</span>
//             </div>
//             <div className="profile-item">
//               <span className="profile-label">Experience:</span>
//               <span className="profile-value">{userData.experience} years</span>
//             </div>
//             <div className="profile-item">
//               <span className="profile-label">Profile Photo:</span>
//               {userData.profilePhoto ? (
//                 <img src={userData.profilePhoto} alt="Profile" className="profile-photo" />
//               ) : (
//                 <span className="profile-value">No Photo Uploaded</span>
//               )}
//             </div>
//           </>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Profile;

// frontend/src/pages/Profile.js
import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../styles/profile.css';
import Chat from '../components/Chat';
import { BsChatDots, BsList } from 'react-icons/bs';
import { countries, states, districts } from '../data/locationData';
import { IoMdClose } from 'react-icons/io';
import { formatMessageDate } from '../F_utils/dateUtils';
import { FaCamera } from 'react-icons/fa';
import { toast } from 'react-toastify';
import AdvocateConsultationPanel from '../components/consultation/AdvocateConsultationPanel';
import UserConsultations from '../components/consultation/UserConsultations';

// Social login profile update popup
const ProfileUpdatePopup = ({ onUpdate, onContinue }) => (
  <div style={{
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    background: 'rgba(0,0,0,0.4)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999
  }}>
    <div style={{
      background: '#fff',
      padding: '32px',
      borderRadius: '12px',
      boxShadow: '0 2px 16px rgba(0,0,0,0.15)',
      maxWidth: '800px',
      textAlign: 'center'
    }}>
      <h2 style={{ color: '#0a74da', marginBottom: '16px' }}>Welcome to ULJAAPP!</h2>
      <p style={{ fontSize: '18px', marginBottom: '24px' }}>
        Please update your profile for accurate results and a better experience.
      </p>
      <div style={{ display: 'flex', justifyContent: 'center', gap: '16px' }}>
        <button
          style={{
            padding: '10px 24px',
            background: '#34a853',
            color: '#fff',
            border: 'none',
            borderRadius: '8px',
            fontSize: '16px',
            cursor: 'pointer'
          }}
          onClick={onUpdate}
        >
          Update
        </button>
        <button
          style={{
            padding: '10px 24px',
            background: '#0a74da',
            color: '#fff',
            border: 'none',
            borderRadius: '8px',
            fontSize: '16px',
            cursor: 'pointer'
          }}
          onClick={onContinue}
        >
          Continue
        </button>
      </div>
    </div>
  </div>
);

const Profile = () => {
  // Ref for profile photo input (for overlay click)
  const profilePhotoInputRef = useRef(null);
  // State for showing the social login profile update popup
  const [showProfileUpdatePopup, setShowProfileUpdatePopup] = useState(false);

  // Effect: Check localStorage for social login flag, show popup after 0.5s
  useEffect(() => {
    if (localStorage.getItem('showProfileUpdatePopup')) {
      setTimeout(() => {
        setShowProfileUpdatePopup(true);
        localStorage.removeItem('showProfileUpdatePopup');
      }, 500);
    }
  }, []);
  // State for user profile data fetched from backend
  const [userData, setUserData] = useState(null);
  // State for loading spinner
  const [loading, setLoading] = useState(true);
  // State for error messages
  const [error, setError] = useState(null);
  // State to toggle edit mode for profile
  const [editMode, setEditMode] = useState(false);
  // State for form data when editing profile
  const [formData, setFormData] = useState({});
  // State for success message after saving profile
  const [successMsg, setSuccessMsg] = useState('');
  // State to show/hide chat list popup for legal advisors
  const [showChatList, setShowChatList] = useState(false);
  // State for active chat conversations
  const [activeChats, setActiveChats] = useState([]);
  // State for currently selected chat user
  const [selectedChat, setSelectedChat] = useState(null);
  // State for chat-related errors
  const [chatError, setChatError] = useState(null);
  // State for tracking which chats have been read (for unread badge)
  const [readChats, setReadChats] = useState(() => {
    // Try to load from localStorage, fallback to empty object
    try {
      const stored = localStorage.getItem("readChats");
      return stored ? JSON.parse(stored) : {};
    } catch {
      return {};
    }
  });
  // State for profile photo upload
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [showAdvanced, setShowAdvanced] = useState(false);
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [confirmText, setConfirmText] = useState('');
  // Verification notification banner (dismissible)
  const [noticeDismissed, setNoticeDismissed] = useState(false);

  // Ref to store chat polling interval for cleanup
  const chatRefreshInterval = useRef(null);
  const fileInputRef = useRef(null);
  const navigate = useNavigate();

  // Effect: Mark chat as read when selectedChat changes
  useEffect(() => {
    if (selectedChat) {
      setReadChats((prev) => {
        const updated = { ...prev, [selectedChat]: Date.now() };
        localStorage.setItem("readChats", JSON.stringify(updated));
        return updated;
      });
    }
  }, [selectedChat]);

  // Function: Fetch and update chat list for legal advisors
  const fetchChats = async () => {
    try {
      const token = localStorage.getItem('token');
      const chatsResponse = await axios.get('/api/auth/chats', {
        headers: { Authorization: `Bearer ${token}` }
      });
      // Sort chats by last message timestamp (descending)
      if (chatsResponse.data && chatsResponse.data.chats) {
        const sortedChats = chatsResponse.data.chats.sort((a, b) => 
          new Date(b.lastMessage) - new Date(a.lastMessage)
        );
        setActiveChats(sortedChats);
      } else {
        setActiveChats([]);
      }
      setChatError(null);
    } catch (chatError) {
      console.error('Error fetching chats:', chatError);
      setActiveChats([]);
      setChatError('Failed to load chats. Please try again later.');
    }
  };

  // Effect: Fetch user profile and initialize chat polling if legal advisor
  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          navigate('/login');
          return;
        }
        // Fetch user profile from backend
        const response = await axios.get('/api/auth/profile', {
          headers: { Authorization: `Bearer ${token}` },
        });
        setUserData(response.data.user);
        setFormData(response.data.user);

        // If user is a legal advisor, fetch their chats and start polling
        if (response.data.user.role === 'LegalAdvisor') {
          await fetchChats();
          // Set up interval to refresh chats every 5 seconds
          chatRefreshInterval.current = setInterval(fetchChats, 5000);
        }
      } catch (error) {
        console.error('Error fetching user details:', error);
        setError('Failed to fetch user details. Please try again.');
      } finally {
        setLoading(false);
      }
    };
    fetchUserDetails();

    // Cleanup: Clear chat polling interval on component unmount
    return () => {
      if (chatRefreshInterval.current) {
        clearInterval(chatRefreshInterval.current);
      }
    };
  }, [navigate]);

  // Function: Handle input changes for simple fields in the edit form
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // Function: Handle file selection for profile photo
  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validate file type
      if (!file.type.startsWith('image/')) {
        setError('Please select an image file (JPEG, PNG, etc.)');
        return;
      }
      
      // Validate file size (max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        setError('File size must be less than 5MB');
        return;
      }

      setSelectedFile(file);
      setError(''); // Clear any previous errors
      
      // Create preview URL
      const reader = new FileReader();
      reader.onload = (e) => {
        setPreviewUrl(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  // Function: Remove selected file
  const handleRemoveFile = () => {
    setSelectedFile(null);
    setPreviewUrl(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  // Function: Enter edit mode
  const handleEdit = () => {
    setEditMode(true);
    setSuccessMsg('');
    setSelectedFile(null);
    setPreviewUrl(null);
    setError('');
    setShowAdvanced(false);
  };

  // Function: Cancel edit mode and reset form data
  const handleCancel = () => {
    setEditMode(false);
    setFormData(userData);
    setSuccessMsg('');
    setSelectedFile(null);
    setPreviewUrl(null);
    setError('');
    setShowAdvanced(false);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  // Function: Save profile changes to backend
  const handleSave = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccessMsg('');
    
    try {
      const token = localStorage.getItem('token');
      
      // If there's a file to upload, use FormData
      if (selectedFile) {
        const formDataToSend = new FormData();
        
        // Add all form fields
        Object.keys(formData).forEach(key => {
          if (formData[key] !== undefined && formData[key] !== null) {
            if (Array.isArray(formData[key])) {
              formData[key].forEach(item => {
                formDataToSend.append(key, item);
              });
            } else {
              formDataToSend.append(key, formData[key]);
            }
          }
        });
        
        // Add the file
        formDataToSend.append('profilePhoto', selectedFile);
        
        const response = await axios.put('/api/auth/profile', formDataToSend, {
          headers: { 
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          },
        });
        
        setUserData(response.data.user);
        setEditMode(false);
        setSelectedFile(null);
        setPreviewUrl(null);
        setSuccessMsg('Profile updated successfully!');
      } else {
        // No file upload, send JSON data
        const response = await axios.put('/api/auth/profile', formData, {
          headers: { Authorization: `Bearer ${token}` },
        });
        
        setUserData(response.data.user);
        setEditMode(false);
        setSuccessMsg('Profile updated successfully!');
      }
    } catch (err) {
      console.error('Profile update error:', err);
      setError('Failed to update profile. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  // Function: Dismiss the verification notification banner
  const handleDismissNotice = async () => {
    setNoticeDismissed(true);
    try {
      const token = localStorage.getItem('token');
      await axios.put('/api/advisor-verification/notice/seen', {}, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (err) {
      // Non-fatal — banner is already hidden locally.
    }
  };

  // Function: Handle chat selection (mark as read)
  const handleChatClick = (userId) => {
    setSelectedChat(userId);
    setReadChats((prev) => ({ ...prev, [userId]: true }));
  };

  // Function: Toggle chat list popup
  const toggleChatList = () => {
    setShowChatList(!showChatList);
    if (!showChatList) {
      setSelectedChat(null);
    }
  };

  // Function: Handle changes for array fields (languages, courts, etc.)
  const handleArrayFieldChange = (field, idx, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: prev[field].map((item, i) => (i === idx ? value : item))
    }));
  };

  // Function: Add a new entry to an array field
  const handleArrayFieldAdd = (field) => {
    setFormData(prev => ({
      ...prev,
      [field]: [...(prev[field] || []), ""]
    }));
  };

  // Function: Remove an entry from an array field
  const handleArrayFieldRemove = (field, idx) => {
    setFormData(prev => ({
      ...prev,
      [field]: prev[field].filter((_, i) => i !== idx)
    }));
  };

  // Loading and error UI
  if (loading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;
  if (!userData) return <p>No user data found.</p>;

  return (
    <>
      {showProfileUpdatePopup && (
        <ProfileUpdatePopup
          onUpdate={() => {
            setShowProfileUpdatePopup(false);
            setEditMode(true);
          }}
          onContinue={() => {
            setShowProfileUpdatePopup(false);
            navigate('/');
          }}
        />
      )}
      <div className="profile-container">
        {/* Heading for profile or edit mode */}
        <h2 className="profile-page-heading" style={{ textAlign: 'center', marginBottom: '24px', color: '#0a74da', fontWeight: 900 }}>
          {editMode ? 'Edit Profile' : 'Profile Page'}
        </h2>
        {/* Profile photo section */}
        <div className="profile-photo-fb-wrapper">
          <div className="profile-photo-fb-circle">
            <img
              src={previewUrl || userData.profilePhoto || '/default-profile.png'}
              alt="Profile"
              className="profile-photo-fb-img"
            />
            {editMode && (
              <>
                <button
                  className="profile-photo-fb-camera"
                  type="button"
                  onClick={() => profilePhotoInputRef.current && profilePhotoInputRef.current.click()}
                  aria-label="Change profile photo"
                >
                  <FaCamera size={32} />
                </button>
                <input
                  ref={profilePhotoInputRef}
                  type="file"
                  accept="image/*"
                  style={{ display: 'none' }}
                  onChange={handleFileSelect}
                />
              </>
            )}
          </div>
        </div>
        <div className="profile-content">
        {/* Verification status notification banner (legal advisors) */}
        {!editMode && userData.role === 'LegalAdvisor'
          && userData.verificationStatus && userData.verificationStatus !== 'unsubmitted'
          && !noticeDismissed && (() => {
            const meta = {
              verified: { bg: '#eafaf1', border: '#37b36a', color: '#1b7a44', icon: '✅', title: 'Your advisor profile is verified' },
              pending: { bg: '#fff8e6', border: '#f0b400', color: '#8a6300', icon: '⏳', title: 'Verification pending review' },
              rejected: { bg: '#fff5f5', border: '#e11d48', color: '#b00020', icon: '❌', title: 'Your application was not approved' },
            }[userData.verificationStatus];
            if (!meta) return null;
            return (
              <div
                className="verification-notice-banner"
                style={{
                  background: meta.bg,
                  border: `1px solid ${meta.border}`,
                  borderLeft: `5px solid ${meta.border}`,
                }}
              >
                <div className="verification-notice-body">
                  <div style={{ fontWeight: 800, color: meta.color, marginBottom: 4 }}>
                    {meta.icon} {meta.title}
                  </div>
                  {userData.verificationStatus === 'rejected' && userData.verificationNotes && (
                    <div style={{ fontSize: 14, color: '#7a1220', marginBottom: 8 }}>
                      <strong>Reason:</strong> {userData.verificationNotes}
                    </div>
                  )}
                  {userData.verificationStatus === 'pending' && (
                    <div style={{ fontSize: 14, color: meta.color }}>
                      Our team is reviewing your document. You'll be notified once it's done.
                    </div>
                  )}
                  {userData.verificationStatus === 'rejected' && (
                    <button
                      type="button"
                      onClick={() => navigate('/become-legal-advisor')}
                      style={{
                        background: meta.border, color: '#fff', border: 'none', borderRadius: 8,
                        padding: '8px 16px', cursor: 'pointer', fontWeight: 600, fontSize: 14,
                      }}
                    >
                      Fix &amp; Re-apply
                    </button>
                  )}
                </div>
                <button
                  type="button"
                  className="verification-notice-close"
                  onClick={handleDismissNotice}
                  aria-label="Dismiss"
                  style={{ color: meta.color }}
                >
                  ×
                </button>
              </div>
            );
          })()}
        {/* Success message after profile update */}
        {successMsg && <div className="profile-success">{successMsg}</div>}
        {editMode ? (
          // Edit mode: show editable form fields
          <form onSubmit={handleSave} className="profile-edit-form">
            {/* Profile Photo Upload Section removed from form, only top image remains */}

            {/* Basic fields */}
            <div className="profile-item">
              <span className="profile-label">First Name:</span>
              <input name="firstName" className="notranslate" translate="no" value={formData.firstName || ''} onChange={handleChange} />
            </div>
            <div className="profile-item">
              <span className="profile-label">Last Name:</span>
              <input name="lastName" className="notranslate" translate="no" value={formData.lastName || ''} onChange={handleChange} />
            </div>
            <div className="profile-item">
              <span className="profile-label">Country:</span>
              <select 
                name="country" 
                value={formData.country || ''} 
                onChange={(e) => {
                  handleChange(e);
                  setFormData(prev => ({ ...prev, state: '', district: '' }));
                }}
                className="profile-select notranslate"
                translate="no"
              >
                <option value="">-- Select Country --</option>
                {countries.map((country) => (
                  <option key={country} value={country}>{country}</option>
                ))}
              </select>
            </div>
            {formData.country && (
              <div className="profile-item">
                <span className="profile-label">State:</span>
                <select 
                  name="state" 
                  value={formData.state || ''} 
                  onChange={(e) => {
                    handleChange(e);
                    setFormData(prev => ({ ...prev, district: '' }));
                  }}
                  className="profile-select notranslate"
                  translate="no"
                >
                  <option value="">-- Select State --</option>
                  {states[formData.country]?.map((state) => (
                    <option key={state} value={state}>{state}</option>
                  ))}
                </select>
              </div>
            )}
            {formData.state && (
              <div className="profile-item">
                <span className="profile-label">District:</span>
                <select 
                  name="district" 
                  value={formData.district || ''} 
                  onChange={handleChange}
                  className="profile-select notranslate"
                  translate="no"
                >
                  <option value="">-- Select District --</option>
                  {districts[formData.state]?.map((district) => (
                    <option key={district} value={district}>{district}</option>
                  ))}
                </select>
              </div>
            )}
            <div className="profile-item">
              <span className="profile-label">Phone:</span>
              <input name="phone" value={formData.phone || ''} onChange={handleChange} />
            </div>
            {/* LegalAdvisor-specific fields */}
            {userData.role === 'LegalAdvisor' && (
              <>
                {/* Enrollment Number */}
                <div className="profile-item">
                  <span className="profile-label">Enrollment Number:</span>
                  <input name="enrollmentNumber" value={formData.enrollmentNumber || ''} onChange={handleChange} />
                </div>
                {/* Practice Areas & Skills (comma separated) */}
                <div className="profile-item">
                  <span className="profile-label">Practice Areas & Skills:</span>
                  <div style={{ flex: 1 }}>
                    {(formData.specialization || "").split(',').map((skill, idx, arr) => (
                      <div key={idx} style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
                        <input
                          style={{ flex: 1 }}
                          value={skill}
                          onChange={e => {
                            const updated = arr.slice();
                            updated[idx] = e.target.value;
                            setFormData(prev => ({
                              ...prev,
                              specialization: updated.join(',')
                            }));
                          }}
                        />
                        {arr.length > 1 && (
                          <button type="button" style={{ marginLeft: 6 }} onClick={() => {
                            const updated = arr.filter((_, i) => i !== idx);
                            setFormData(prev => ({
                              ...prev,
                              specialization: updated.join(',')
                            }));
                          }}>Remove</button>
                        )}
                      </div>
                    ))}
                    <button type="button" onClick={() => setFormData(prev => ({
                      ...prev,
                      specialization: prev.specialization ? prev.specialization + ',' : ''
                    }))}>Add</button>
                  </div>
                </div>
                {/* Languages Known (multiple entries) */}
                <div className="profile-item">
                  <span className="profile-label">Languages Known:</span>
                  <div style={{ flex: 1 }}>
                    {(formData.languagesKnown && Array.isArray(formData.languagesKnown) ? formData.languagesKnown : (formData.languagesKnown || '').split(',')).map((lang, idx, arr) => (
                      <div key={idx} style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
                        <input
                          style={{ flex: 1 }}
                          value={lang}
                          onChange={e => handleArrayFieldChange('languagesKnown', idx, e.target.value)}
                        />
                        {arr.length > 1 && (
                          <button type="button" style={{ marginLeft: 6 }} onClick={() => handleArrayFieldRemove('languagesKnown', idx)}>Remove</button>
                        )}
                      </div>
                    ))}
                    <button type="button" onClick={() => handleArrayFieldAdd('languagesKnown')}>Add</button>
                  </div>
                </div>
                {/* Primary Practice Areas (multiple entries) */}
                <div className="profile-item">
                  <span className="profile-label">Primary Practice Area(s):</span>
                  <div style={{ flex: 1 }}>
                    {(formData.primaryPracticeAreas && Array.isArray(formData.primaryPracticeAreas) ? formData.primaryPracticeAreas : (formData.primaryPracticeAreas || '').split(',')).map((court, idx, arr) => (
                      <div key={idx} style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
                        <input
                          style={{ flex: 1 }}
                          value={court}
                          onChange={e => handleArrayFieldChange('primaryPracticeAreas', idx, e.target.value)}
                        />
                        {arr.length > 1 && (
                          <button type="button" style={{ marginLeft: 6 }} onClick={() => handleArrayFieldRemove('primaryPracticeAreas', idx)}>Remove</button>
                        )}
                      </div>
                    ))}
                    <button type="button" onClick={() => handleArrayFieldAdd('primaryPracticeAreas')}>Add</button>
                  </div>
                </div>
                {/* Address */}
                <div className="profile-item">
                  <span className="profile-label">Address:</span>
                  <input name="address" value={formData.address || ''} onChange={handleChange} />
                </div>
                {/* About section */}
                <div className="profile-item">
                  <span className="profile-label">About:</span>
                  <textarea
                    name="about"
                    value={formData.about || ''}
                    onChange={handleChange}
                    rows={3}
                    style={{ width: '100%', borderRadius: 6, padding: 8, fontSize: '1rem', border: '1px solid #ddd' }}
                  />
                </div>
              </>
            )}
            {/* Save/Cancel buttons */}
            <div className="profile-edit-actions">
              <button type="submit" className="profile-save-btn">Save</button>
              <button type="button" className="profile-cancel-btn" onClick={handleCancel}>Cancel</button>
            </div>
          </form>
        ) : (
          // View mode: show profile fields
          <>
            <div className="profile-item">
              <span className="profile-label">First Name:</span>
              <span className="profile-value notranslate" translate="no">{userData.firstName}</span>
            </div>
            <div className="profile-item">
              <span className="profile-label">Last Name:</span>
              <span className="profile-value notranslate" translate="no">{userData.lastName}</span>
            </div>
            <div className="profile-item">
              <span className="profile-label">Country:</span>
              <span className="profile-value">{userData.country}</span>
            </div>
            <div className="profile-item">
              <span className="profile-label">State:</span>
              <span className="profile-value">{userData.state}</span>
            </div>
            <div className="profile-item">  
              <span className="profile-label">District:</span>
              <span className="profile-value">{userData.district}</span>
            </div>
            <div className="profile-item">
              <span className="profile-label">Phone:</span>
              <span className="profile-value">{userData.phone}</span>
            </div>
            <div className="profile-item">
              <span className="profile-label">Email:</span>
              <span className="profile-value notranslate" translate="no">{userData.emailOrPhone || userData.email}</span>
            </div>
            {/* LegalAdvisor-specific fields */}
            {userData.role === 'LegalAdvisor' && (
              <>
                <div className="profile-item">
                  <span className="profile-label">Enrollment Number:</span>
                  <span className="profile-value">{userData.enrollmentNumber}</span>
                </div>
                <div className="profile-item">
                  <span className="profile-label">Practice Areas & Skills:</span>
                  <span className="profile-value">{userData.specialization}</span>
                </div>
                <div className="profile-item">
                  <span className="profile-label">Experience:</span>
                  <span className="profile-value">{userData.experience} years</span>
                </div>
                <div className="profile-item">
                  <span className="profile-label">Languages Known:</span>
                  <span className="profile-value">
                    {userData.languagesKnown && userData.languagesKnown.length > 0
                      ? userData.languagesKnown.join(', ')
                      : 'N/A'}
                  </span>
                </div>
                <div className="profile-item">
                  <span className="profile-label">Primary Practice Area(s):</span>
                  <span className="profile-value">
                    {userData.primaryPracticeAreas && userData.primaryPracticeAreas.length > 0
                      ? userData.primaryPracticeAreas.join(', ')
                      : 'N/A'}
                  </span>
                </div>
                <div className="profile-item">
                  <span className="profile-label">Address:</span>
                  <span className="profile-value">{userData.address || 'N/A'}</span>
                </div>
                <div className="profile-item">
                  <span className="profile-label">About:</span>
                  <span className="profile-value">{userData.about || 'N/A'}</span>
                </div>
              </>
            )}
            <div className="profile-edit-actions">
              <button className="profile-edit-btn" onClick={handleEdit}>Edit</button>
            </div>
            {userData.role === 'LegalAdvisor' && userData.isVerified && (
              <AdvocateConsultationPanel />
            )}
            <UserConsultations />
          </>
        )}

        {/* Floating Chat UI for Legal Advisors */}
        {userData.role === 'LegalAdvisor' && (
          <>
            {/* Floating button to open chat list */}
            <button className="chat-list-button" onClick={toggleChatList} title="Chat List">
              {showChatList ? <IoMdClose size={24} /> : <BsList size={24} />}
            </button>

            {/* Chat list popup */}
            {showChatList && (
              <div className={`chat-list-popup ${selectedChat ? 'with-active-chat' : ''}`}>
                <div className="chat-list-header">
                  <h3>Active Chats</h3>
                  <button className="close-button" onClick={() => setShowChatList(false)}>
                    <IoMdClose size={20} />
                  </button>
                </div>
                <div className="chat-list-content">
                  {chatError ? (
                    <div className="chat-error">{chatError}</div>
                  ) : activeChats.length === 0 ? (
                    <div className="chat-item">No active chats</div>
                  ) : (
                    activeChats.map((chat) => {
                      // Find the other user in the chat
                      const otherUser = chat.participants.find(p => p._id !== userData._id);
                      const lastMessage = chat.messages[chat.messages.length - 1];
                      // Only show unread badge if there are unread messages after last read
                      const unreadMessages = chat.messages.filter(
                        msg =>
                          !msg.deletedFor?.includes(userData._id) &&
                          !msg.deletedForEveryone &&
                          msg.sender._id !== userData._id &&
                          !msg.readBy?.includes(userData._id)
                      );
                      // Find the timestamp of the last read for this chat
                      const lastRead = readChats[otherUser._id] || 0;
                      // Only count messages after lastRead
                      const trulyUnread = unreadMessages.filter(msg => new Date(msg.timestamp).getTime() > lastRead);
                      const unreadCount = trulyUnread.length;
                      // Hide badge if chat is open or all unread messages have been read
                      const isChatOpen = selectedChat === otherUser._id;
                      return (
                        <div
                          key={chat._id}
                          className={`chat-item ${selectedChat === otherUser._id ? 'active' : ''} ${unreadCount > 0 ? 'unread' : ''}`}
                          onClick={() => setSelectedChat(otherUser._id)}
                        >
                          <div className="chat-user-info">
                            <div className="chat-user-header">
                              <span className="chat-user-name notranslate" translate="no">
                                {otherUser.firstName} {otherUser.lastName}
                              </span>
                              {unreadCount > 0 && !isChatOpen && (
                                <span className="unread-badge">{unreadCount}</span>
                              )}
                            </div>
                            <div className="chat-message-preview">
                              <span className="chat-last-message">
                                {lastMessage?.deletedForEveryone ?
                                  'This message was deleted' :
                                  lastMessage?.deletedFor?.includes(userData._id) ?
                                  'You deleted this message' :
                                  lastMessage?.content || 'No messages yet'}
                              </span>
                              <span className="chat-time">
                                {lastMessage ? formatMessageDate(lastMessage.timestamp) : ''}
                              </span>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  )}
                </div>
              </div>
            )}

            {/* Active chat window */}
            {selectedChat && (
              <div className={`active-chat-window ${!showChatList ? 'mobile-view' : ''}`}>
                <div className="active-chat-header">
                  <h3>
                    {activeChats.find(chat => 
                      chat.participants.some(p => p._id === selectedChat))
                      ?.participants.find(p => p._id === selectedChat)
                      ?.firstName || 'Chat'}
                  </h3>
                  <button className="close-button" onClick={() => setSelectedChat(null)}>
                    <IoMdClose size={20} />
                  </button>
                </div>
                <div className="active-chat-content">
                  <Chat 
                    advisorId={userData._id} 
                    userId={selectedChat} 
                    onNewMessage={() => fetchChats()} // Refresh chat list when new message is sent
                  />
                </div>
              </div>
            )}
          </>
        )}

        {editMode && (
          <>
            {/* Advanced settings toggle (hidden control) */}
            <div style={{ marginTop: 24 }}>
              <button
                type="button"
                onClick={() => setShowAdvanced(v => !v)}
                style={{
                  background: 'transparent',
                  border: 'none',
                  color: '#666',
                  textDecoration: 'underline',
                  cursor: 'pointer'
                }}
                aria-expanded={showAdvanced}
              >
                {showAdvanced ? 'Hide advanced' : 'Advanced settings'}
              </button>
            </div>

            {showAdvanced && (
              <div style={{ marginTop: 12, borderTop: '1px solid #eee', paddingTop: 16 }}>
                <div style={{
                  background: '#fff5f5',
                  border: '1px solid #ffd6d6',
                  borderRadius: 8,
                  padding: 16
                }}>
                  <div style={{ fontWeight: 700, color: '#b00020', marginBottom: 8 }}>Danger Zone</div>
                  <div style={{ fontSize: 14, color: '#b00020', marginBottom: 12 }}>
                    Permanently delete your account and all associated data.
                  </div>
                  <button
                    type="button"
                    onClick={() => setConfirmDeleteOpen(true)}
                    style={{
                      background: '#d32f2f',
                      color: '#fff',
                      border: 'none',
                      borderRadius: 6,
                      padding: '10px 14px',
                      cursor: 'pointer'
                    }}
                  >
                    Delete account
                  </button>
                </div>
              </div>
            )}
          </>
        )}
      </div>
  </div>

    {confirmDeleteOpen && (
      <div style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10000
      }}>
        <div style={{ background: '#fff', padding: 24, borderRadius: 10, maxWidth: 420, width: '90%' }}>
          <h3 style={{ marginTop: 0, marginBottom: 8 }}>Confirm account deletion</h3>
          <p style={{ marginTop: 0, color: '#555' }}>
            Type DELETE to confirm. This action cannot be undone.
          </p>
          <input
            value={confirmText}
            onChange={(e) => setConfirmText(e.target.value)}
            placeholder="Type DELETE"
            style={{ width: '100%', padding: 10, border: '1px solid #ccc', borderRadius: 6 }}
          />
          <div style={{ display: 'flex', gap: 8, marginTop: 16, justifyContent: 'flex-end' }}>
            <button
              type="button"
              onClick={() => { setConfirmDeleteOpen(false); setConfirmText(''); }}
              style={{ background: '#eee', border: 'none', borderRadius: 6, padding: '8px 12px', cursor: 'pointer' }}
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={async () => {
                if (confirmText.trim() !== 'DELETE') {
                  toast.error('Please type DELETE to confirm');
                  return;
                }
                try {
                  const token = localStorage.getItem('token');
                  if (!token) {
                    navigate('/login');
                    return;
                  }
                  await axios.delete('/api/auth/account', {
                    headers: { Authorization: `Bearer ${token}` }
                  });
                  toast.success('Your account has been deleted');
                  localStorage.removeItem('token');
                  navigate('/login');
                  window.location.reload();
                } catch (err) {
                  console.error('Delete account error:', err);
                  toast.error(err?.response?.data?.msg || 'Failed to delete account');
                }
              }}
              style={{ background: '#d32f2f', color: '#fff', border: 'none', borderRadius: 6, padding: '8px 12px', cursor: 'pointer' }}
            >
              Confirm delete
            </button>
          </div>
        </div>
      </div>
    )}
  </>
  );
};

export default Profile;


